import script from "./SeguimientoPlanView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SeguimientoPlanView.vue?vue&type=script&lang=ts&setup=true"

import "./SeguimientoPlanView.vue?vue&type=style&index=0&id=1b5c6c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5c6c60"]])

export default __exports__